import { HTTPClient } from "@abaco/web-common/src/HTTP";
import {
  DownloadRequestDto,
  DownloadResponseDto,
  DownloadFileRequestDto,
  DownloadStatusResponseDto,
  RoleUserMapDto
} from "../models/cruscottoLoggingApplicativoModel";

const PMI_LOGGING_ENDPOINTS: Record<string, string> = {
  TEST: "https://test-abaco-pmi-logging-api.bluarancio.com",
  COLLAUDO: "https://colladuo-abaco-pmi-logging-api.bluarancio.com",
  PRODUZIONE: "https://demetra-abaco-pmi-logging-api.bluarancio.com",
};

function getPmiLoggingEnv(): keyof typeof PMI_LOGGING_ENDPOINTS {
  const host = window.location.hostname.toLowerCase();
  if (host.includes("colladuo")) return "COLLAUDO";
  if (host.includes("demetra")) return "PRODUZIONE";
  return "TEST";
}

export default class CruscottoLoggingApplicativoApi {
  private http: HTTPClient;
  private baseUrl: string;

  constructor(http: HTTPClient) {
    this.http = http;
    const isLocal = typeof window !== "undefined" &&
      (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");
    const env = getPmiLoggingEnv();
    this.baseUrl = isLocal ? "/pmi-logging-api" : PMI_LOGGING_ENDPOINTS[env];
  }

  private uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

public async getRolesAndUsers(): Promise<RoleUserMapDto[]> {
    const res = await this.http.get(`${this.baseUrl}/api/users/roles`, {
      headers: {
        'X-Request-Id': this.uuidv4(),
      }
    });
    return res.data;
  }

  public async startDownload(request: DownloadRequestDto): Promise<DownloadResponseDto> {
    const res = await this.http.post(`${this.baseUrl}/api/download/start`, request, {
      headers: { 'X-Request-Id': this.uuidv4() }
    });
    return res.data;
  }

  public async getDownloadStatus(filename: string, path: string): Promise<DownloadStatusResponseDto> {
    const res = await this.http.get(`${this.baseUrl}/api/download/status`, {
      params: { filename, path },
      headers: { 'X-Request-Id': this.uuidv4() }
    });
    return res.data;
  }

  public async downloadFile(request: DownloadFileRequestDto): Promise<Blob> {
    const res = await this.http.post(`${this.baseUrl}/api/download/file`, request, {
      headers: { 'X-Request-Id': this.uuidv4() },
      responseType: "blob"
    });
    return res.data;
  }

}

